import {CreativeTemplate, CreativeTemplateFeature} from '../creativeTemplates.types';
import {TemplateEssentials} from '../../creatives/creatives.types';

function isContentSupportedTemplate(template: CreativeTemplate | TemplateEssentials): boolean {
  return !!template.features?.includes(CreativeTemplateFeature.Content);
}

export default isContentSupportedTemplate;
